import { z } from 'zod';
import { senhaSchema } from '../auth/equipe.js';
/**
 * De que time é o técnico, e portanto em qual fila ele cai.
 *
 * `campo` instala e repara na casa do cliente, e pede liberação de sinal. `rede` cuida dos
 * equipamentos e fala com o NOC. Antes de 15/10 havia um tipo só, e todo mundo que estava
 * cadastrado virou `campo` na migração.
 */
export const TIPOS_TECNICO = ['campo', 'rede'];
/** Como cada tipo aparece na tela. */
export const ROTULO_TIPO_TECNICO = {
    campo: 'Campo',
    rede: 'Rede',
};
/**
 * Técnico credenciado: de campo (liberação de sinal) ou de rede (NOC).
 *
 * Entra pelo mesmo chat do cliente, no mesmo campo — digita o e-mail onde o cliente
 * digitaria o CPF. Não é cliente da Maxx: não tem documento nem cadastro no ERP.
 */
export const tecnicoFormSchema = z.object({
    nome: z.string().trim().min(3, 'Informe o nome completo').max(120),
    email: z.email('Informe um e-mail válido').trim().toLowerCase().max(150),
    // Sem padrão de propósito: quem cadastra escolhe. Um padrão silencioso faria todo
    // técnico de rede nascer como de campo e cair na fila errada, e o erro só apareceria
    // no dia em que ele precisasse do NOC.
    tipo: z.enum(TIPOS_TECNICO, { message: 'Escolha se o técnico é de campo ou de rede' }),
    ativo: z.boolean().default(true),
});
/** Cadastro inicial: o admin entrega a senha, e o técnico é obrigado a trocar ao entrar. */
export const novoTecnicoSchema = tecnicoFormSchema.extend({ senha: senhaSchema });
export const senhaTecnicoSchema = z.object({ senha: senhaSchema });
//# sourceMappingURL=tecnicos.js.map